import DraftAppsResource from './resources';
import DraftAppsObbResource from './obbReources';

import transformError from '@/api/shared/transformers/errorTransformer';
import getFormData from '@/utils/getFormData';

export default {
  getList() {
    return DraftAppsResource.get()
      .then(({ body }) => body)
      .catch(transformError);
  },

  get(id) {
    return DraftAppsResource.get({ id })
      .then(({ body }) => body)
      .catch(transformError);
  },

  createNew() {
    return DraftAppsResource.save()
      .then(({ body }) => body)
      .catch(transformError);
  },

  changeState({ id, currentState, nextState, data }) {
    return DraftAppsResource.changeState(
      { id },
      {
        currentState,
        nextState,
        ...data,
      },
    )
      .then(({ body }) => body)
      .catch(transformError);
  },

  publish({ id, currentState, data }) {
    const body = new FormData();
    body.append('current_state', currentState);
    // C stands for "Committed" state
    body.append('next_state', 'C');
    body.append('developer_note', data.developerNote);
    body.append('auto_publish', data.autoPublish);

    if (data.developerFile) {
      body.append('developer_file', data.developerFile);
    }

    return DraftAppsResource.changeState({ id }, body)
      .then(({ body }) => body)
      .catch(transformError);
  },

  delete(id) {
    return DraftAppsResource.delete({ id })
      .then(({ body }) => body)
      .catch(transformError);
  },

  removePackage({ id, packageId }) {
    return DraftAppsResource.removePackage({ id, resourceId: packageId })
      .then(({ body }) => body)
      .catch(transformError);
  },

  uploadIcon({ id, icon }) {
    const formData = getFormData([icon], 'file');

    return DraftAppsResource.uploadIcon({ id }, formData)
      .then(({ body }) => body)
      .catch(transformError);
  },

  uploadScreenshot({ id, screenshot }) {
    const formData = getFormData([screenshot], 'file');

    return DraftAppsResource.uploadScreenshot({ id }, formData)
      .then(({ body }) => body)
      .catch(transformError);
  },

  deleteScreenshot({ id, token }) {
    return DraftAppsResource.deleteScreenshot({ id, resourceId: token })
      .then(({ body }) => body)
      .catch(transformError);
  },

  uploadPromotionScreenshot({ id, screenshot }) {
    const formData = getFormData([screenshot], 'file');

    return DraftAppsResource.uploadPromotionScreenshot({ id }, formData)
      .then(({ body }) => body)
      .catch(transformError);
  },

  deletePromotionScreenshot({ id, token }) {
    return DraftAppsResource.deletePromotionScreenshot({
      id,
      resourceId: token,
    })
      .then(({ body }) => body)
      .catch(transformError);
  },

  getMainObbs(id) {
    return DraftAppsObbResource.getMainObbs({ id })
      .then(({ body }) => body)
      .catch(transformError);
  },

  getPatchObbs({ id, mainObbId }) {
    return DraftAppsObbResource.getPatchObbs({ id, fileId: mainObbId })
      .then(({ body }) => body)
      .catch(transformError);
  },

  attachObbToPackage({ id, packageId, obbId }) {
    return DraftAppsObbResource.attachToPackage(
      { id, fileId: packageId },
      { obbId },
    )
      .then(({ body }) => body)
      .catch(transformError);
  },

  detachObbfromPackage({ id, packageId, obbId }) {
    return DraftAppsObbResource.detach({ id, packageId, fileId: obbId })
      .then(({ body }) => body)
      .catch(transformError);
  },

  updatePackageArchitecture({ id, packageId, architecture }) {
    return DraftAppsResource.updatePackageArchitecture(
      { id, resourceId: packageId },
      { cpu_architectures: architecture },
    )
      .then(({ body }) => body)
      .catch(transformError);
  },

  deleteRelease(id) {
    return DraftAppsResource.deleteRelease({ id })
      .then(({ body }) => body)
      .catch(transformError);
  },

  getRSAKey({ id }) {
    return DraftAppsResource.getRSAKey({ id })
      .then(({ body }) => body)
      .catch(transformError);
  },
  getDynamicPriceKey({ id }) {
    return DraftAppsResource.getDynamicPriceKey({ id })
      .then(({ body }) => body)
      .catch(transformError);
  },
};
